import { render, staticRenderFns } from "./ClosedPools.vue?vue&type=template&id=02a30c72&"
import script from "./ClosedPools.vue?vue&type=script&lang=js&"
export * from "./ClosedPools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports